import { render, staticRenderFns } from "./SetUpYZ.vue?vue&type=template&id=7f7edef8&"
import script from "./SetUpYZ.vue?vue&type=script&lang=js&"
export * from "./SetUpYZ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports